import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { AiFillStar } from "react-icons/ai";
import { FiShoppingCart } from "react-icons/fi";

const ProductCard = ({ product }) => {

  const { addToCart } = useCart();

  const [isHovered, setIsHovered] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleAddToCart = () => {
    addToCart(product);
  };

  return (
    <motion.div
      whileHover={{ y: -10 }}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      className="group bg-white dark:bg-gray-800 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition duration-300"
    >

      {/* Product Image */}

      <div className="relative h-96 overflow-hidden">

        {!imageLoaded && (
          <div className="absolute inset-0 bg-gray-200 animate-pulse" />
        )}

        <img
          src={product.image}
          alt={product.name}
          className={`w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 ${
            imageLoaded ? "opacity-100" : "opacity-0"
          }`}
          onLoad={() => setImageLoaded(true)}
        />

        {product.discount && (
          <div className="absolute top-4 left-4 bg-yellow-500 text-black text-xs font-bold px-3 py-1 rounded-full">
            -{product.discount}%
          </div>
        )}

      </div>

      {/* Product Details */}

      <div className="p-6">

        <h3 className="text-xl font-semibold mb-2 line-clamp-2">
          {product.name}
        </h3>

        <div className="flex items-center mb-4">

          <div className="flex text-yellow-500">

            {[...Array(5)].map((_, i) => (
              <AiFillStar key={i} className="w-4 h-4" />
            ))}

          </div>

          <span className="text-sm text-gray-500 ml-2">
            ({product.rating})
          </span>

        </div>

        <div className="flex items-center justify-between mb-6">

          <div>

            <span className="text-2xl font-bold">
              ₹{product.price.toLocaleString()}
            </span>

            {product.originalPrice && (
              <span className="text-sm text-gray-500 line-through ml-3">
                ₹{product.originalPrice.toLocaleString()}
              </span>
            )}

          </div>

        </div>

        {/* Buttons */}

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isHovered ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.3 }}
          className="flex flex-col space-y-3"
        >

          <Link
            to={`/product/${product._id}`}
            className="w-full bg-yellow-500 hover:bg-yellow-600 text-black font-semibold py-3 rounded-xl text-center transition"
          >
            View Details
          </Link>

          <button
            onClick={handleAddToCart}
            className="w-full bg-black hover:bg-gray-900 text-white py-3 rounded-xl flex items-center justify-center gap-2 transition"
          >
            <FiShoppingCart />
            Add to Cart
          </button>

        </motion.div>

      </div>

    </motion.div>
  );
};

export default ProductCard;